'use client'
const MenuButton = ({
  onClick,
  status = 'closed',
}: {
  onClick: () => void
  status: string
}) => (
  <button
    type='button'
    data-status={status}
    aria-label='Menu'
    className='airc-menu-button'
    onClick={onClick}
  >
    <span></span>
  </button>
)

export default MenuButton
